<template>
  <b-modal
    hide-footer
    size="xl"
    id="client-create-modal"
    :title="$t('Create') + ' ' + $t('a.client') + ' ' + $t(clientType)"
  >
    <b-form @submit.stop.prevent="onSubmit">

      <b-form-group
        v-if="form.isAgency.value === true"
        id="agencyName-input"
        :label="$t('agency.fullName')+'*'"
        label-for="agencyName-input"
        class="bold-label"
        :invalid-feedback="form.agencyName.invalidFeedback"
        :state="form.agencyName.state"
      >
        <b-form-input
          id="agencyName-input"
          :placeholder="$t('agency.fullName')"
          v-model="form.agencyName.value"
          type="text"
          maxlength="250"
          :state="form.agencyName.state"
          required
        ></b-form-input>
      </b-form-group>

      <div class="row">
        <div class="col-12 col-md-6">
          <b-form-group
            id="lastName-input"
            :label="$t('client.LastName') + (form.isAgency.value ? '' : '*')"
            label-for="lastName-input"
            class="bold-label"
            :invalid-feedback="form.lastName.invalidFeedback"
            :state="form.lastName.state"
          >
            <b-form-input
              id="lastName-input"
              :placeholder="$t('client.LastName')"
              v-model="form.lastName.value"
              type="text"
              maxlength="250"
              :state="form.lastName.state"
              :required="!form.isAgency.value"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group
            id="firstName-input"
            :label="$t('client.FirstName')"
            label-for="firstName-input"
            class="bold-label"
            :invalid-feedback="form.firstName.invalidFeedback"
            :state="form.firstName.state"
          >
            <b-form-input
              id="firstName-input"
              :placeholder="$t('client.FirstName')"
              v-model="form.firstName.value"
              type="text"
              maxlength="250"
              :state="form.firstName.state"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group
        id="civility-input"
        :label="$t('client.Civility')"
        label-for="civility-input"
        class="bold-label"
        :invalid-feedback="form.civility.invalidFeedback"
        :state="form.civility.state"
      >
        <b-form-radio-group
          v-model="civilitySelected"
          :options="civilityOption"
          class="mb-3"
          value-field="item"
          text-field="name"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        id="phoneNumber-input"
        :label="$t('client.PhoneNumber')"
        label-for="phoneNumber-input"
        class="bold-label"
        :invalid-feedback="form.phoneNumber.invalidFeedback"
        :state="form.phoneNumber.state"
      >
        <b-form-input
          id="phoneNumber-input"
          :placeholder="$t('client.PhoneNumber')"
          v-model="form.phoneNumber.value"
          type="text"
          maxlength="250"
          :state="form.phoneNumber.state"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="cellphoneNumber-input"
        :label="$t('client.CellphoneNumber')"
        label-for="cellphoneNumber-input"
        class="bold-label"
        :invalid-feedback="form.cellphoneNumber.invalidFeedback"
        :state="form.cellphoneNumber.state"
      >
        <b-form-input
          id="cellphoneNumber-input"
          :placeholder="$t('client.CellphoneNumber')"
          v-model="form.cellphoneNumber.value"
          type="text"
          maxlength="250"
          :state="form.cellphoneNumber.state"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="email-input"
        :label="$t('client.Email')"
        label-for="email-input"
        class="bold-label"
        :invalid-feedback="form.email.invalidFeedback"
        :state="form.email.state"
      >
        <b-form-input
          id="email-input"
          :placeholder="$t('client.Email')"
          v-model="form.email.value"
          type="email"
          maxlength="250"
          :state="form.email.state"
        ></b-form-input>
      </b-form-group>

      <div v-if="clientType !== 'tenant'">
        <div>
          <div class="card-subtitle main-color mt-4">{{$t('applicant.address')}} ({{$t('not.mandatory')}})</div>
          <div class="mb-3">{{$t('billing.address.message')}} <b class="bold-text">({{$t('billing.not.intervention')}})</b></div>
        </div>

        <div v-if="clientType === 'owner'">
          <b-form-checkbox
            id="billingAddressDifferent-input"
            v-model="billingAddressDifferent"
          >
            <div class="bold-text mb-2"> {{$t('billing.address.checkbox.label')}}</div>
          </b-form-checkbox>
        </div>

        <div v-if="clientType === 'agency' || billingAddressDifferent">
          <b-form-group
            id="address-input"
            :label="$t('client.Address')"
            label-for="address-input"
            class="bold-label"
            :invalid-feedback="form.address.invalidFeedback"
            :state="form.address.state"
          >
            <b-form-input
              id="address-input"
              :placeholder="$t('number.and.address')"
              v-model="form.address.value"
              type="text"
              maxlength="250"
              :state="form.address.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="additionalAddress-input"
            :label="$t('addressIntervention.AdditionalAddress')"
            label-for="additionalAddress-input"
            class="bold-label"
            :invalid-feedback="form.additionalAddress.invalidFeedback"
            :state="form.additionalAddress.state"
          >
            <b-form-input
              id="additionalAddress-input"
              :placeholder="$t('addressIntervention.AdditionalAddress')"
              v-model="form.additionalAddress.value"
              type="text"
              maxlength="250"
              :state="form.additionalAddress.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="postalCode-input"
            :label="$t('addressIntervention.postalCode')"
            label-for="postalCode-input"
            class="bold-label"
            :invalid-feedback="form.postalCode.invalidFeedback"
            :state="form.postalCode.state"
          >
            <b-form-input
              id="postalCode-input"
              :placeholder="$t('addressIntervention.postalCode')"
              v-model="form.postalCode.value"
              type="number"
              maxlength="6"
              :state="form.postalCode.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="city-input"
            :label="$t('addressIntervention.city')"
            label-for="city-input"
            class="bold-label"
            :invalid-feedback="form.city.invalidFeedback"
            :state="form.city.state"
          >
            <b-form-input
              id="city-input"
              :placeholder="$t('addressIntervention.city')"
              v-model="form.city.value"
              type="text"
              maxlength="250"
              :state="form.city.state"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>


      <div class="d-flex justify-content-end" v-if="!hideSendButton">
        <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
      </div>
    </b-form>
  </b-modal>

</template>

<script>

import api from '../../services/api';

export default {
  name: 'ClientCreateModal',

  emits: ['didCreateClient'],

  props: {
    clientType: String
  },

  data() {
    return {
      civilityOption: [
        {item: "MR", name: "Monsieur"},
        {item: "MME", name: "Madame"},
      ],
      civilitySelected: "MME",
      hideSendButton: false,
      form: {
        cellphoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        email:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        civility:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        isAgency:
          {
            state: null,
            invalidFeedback: null,
            value: false
          },
        agencyName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        additionalAddress:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
      billingAddressDifferent: false,
    }
  },

  watch: {
    'clientType': function () {
      this.form.isAgency.value = this.clientType === "agency";
    }
  },

  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.form.cellphoneNumber.value = null
      this.form.phoneNumber.value = null
      this.form.email.value = null
      this.form.firstName.value = null
      this.form.lastName.value = null
      this.form.agencyName.value = null
      this.form.civility.value = null
      this.form.address.value = null
      this.form.additionalAddress.value = null
      this.form.city.value = null
      this.form.postalCode.value = null
    })
  },

  methods: {
    onSubmit() {
      let data = new FormData()
      data.append('isAgency', this.form.isAgency.value)
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('civility', this.civilitySelected)
      if(this.form.email.value && this.form.email.value.trim() !== ""){
        data.append('email', this.form.email.value)
      }
      if(this.form.agencyName.value && this.form.agencyName.value.trim() !== ""){
        data.append('agencyName', this.form.agencyName.value)
      }
      if (this.form.phoneNumber.value && this.form.phoneNumber.value.trim() !== "") {
        data.append('phoneNumber', this.form.phoneNumber.value)
      }
      if (this.form.cellphoneNumber.value && this.form.cellphoneNumber.value.trim() !== "") {
        data.append('cellphoneNumber', this.form.cellphoneNumber.value)
      }
      if (this.form.address.value && this.form.address.value.trim() !== "") {
        data.append('address', this.form.address.value)
      }
      if (this.form.postalCode.value && this.form.postalCode.value.trim() !== "") {
        data.append('postalCode', this.form.postalCode.value)
      }
      if (this.form.city.value && this.form.city.value.trim() !== "") {
        data.append('city', this.form.city.value)
      }
      if (this.form.additionalAddress.value && this.form.additionalAddress.value.trim() !== "") {
        data.append('additionalAddress', this.form.additionalAddress.value)
      }

      this.hideSendButton = true

      api({
        method: 'POST',
        url: `client`,
        data: data
      })
        .then((response) => {
          let toSend = {value: response.data.id, text: response.data.isAgency ? response.data.agencyName : response.data.name}
          this.successToast(this.form.firstName.value + " " + this.form.lastName.value)
          this.$emit('didCreateClient', toSend)
          this.hideSendButton = false
        })
        .catch((error) => {
          this.hideSendButton = false
          if (error.response && error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(clientName) {
      this.$bvToast.toast(this.$i18n.t('Client') + ' "' + clientName + '" ' + this.$i18n.t('added'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/client/ClientCreateModal.vue